import DataTablePagination from "./DataTablePagination";
import DeleteConfirm from "./DeleteConfirm";

export const DataTableMixin = {
    props:{
        requestUrl: {required: true},
        getRequest: {required: false}
    },
    data(){
        return {
            loading: false,
            response : { //Defining the default object for send to children
                meta:{
                    current_page: 0,
                    from: 0,
                    last_page: 0,
                    path: '0',
                    per_page: 0,
                    to: 0,
                    total: 0
                },
                data:[],
                links:{},
            },
            params : {},
            filtersTemp: {},
            routes : {
                index_data : this._requestUrl+'/index_data',
                view : this._requestUrl+'/index_data',
            }
        }
    },
    beforeMount(){
        this.filtersTemp = {...this.getQueryParams()};
        let params = {...this.params};
        Object.assign(params, this.filtersTemp);
        this.params = params;
    },
    computed: {
        _requestUrl() {
            return this.requestUrl;
        }
    },
    methods: {
        request(){
            this.loading = true;
            const token = localStorage.getItem('_token');
            let config = {
                params: this.params,
            };
            if (token) {
                config.headers = {Authorization: `Bearer ${token}`};
            }
            this.axios.get(this._requestUrl, config).then(response => {
                this.loading = false;
                this.response = response.data;

                let target_url = window.location.href;

                if(target_url.indexOf('?') >= 0)
                    target_url = target_url.substr(0, target_url.indexOf('?'));

                if (Object.keys(this.params).length!==0) {
                    target_url += '?'+this.serializeObjectToQuery(this.params);
                }
                window.history.pushState(null, null, target_url);
                this.onSuccessful();
            });

        },
        onSuccessful() {

        },
        sortIcon(header){
            if(this.params.order_by == header){
                return '<i class="fa fa-sort-'+(this.params.order_dir=='asc' ? 'up' : 'down')+'"><i>';
            }else{
                return '';
            }
        },
        setSortTo(item){
            if(this.params.order_by == item){
                this.params.order_dir = this.params.order_dir == 'asc' ? 'desc' : 'asc'
            }else{
                this.params.order_by = item;
                this.params.order_dir = 'asc';
            }

        },
        doFilter(){
            //this.params.filters = Object.assign({}, this.filtersTemp);
            let params = Object.assign(this.params, this.filtersTemp);

            //Reset pagination on changing filters
            params.page = 1;

            //Assign params to the params prop to do filter
            this.params = params;
        },
        resetFilter(){
            let params = Object.assign({},this.params);

            params.page = 1;

            for (const key of Object.keys(this.filtersTemp)) {
                delete params[key];
            }

            this.filtersTemp = {};

            this.params = params;
        }
    },
    watch: {
        params: {
            deep: true,
            handler(){
                this.request();
            }
        },
    },
    components: {
        DataTablePagination,
        DeleteConfirm,
        ViewLink: {
            props: {link: {required: true}},
            template: `
                <a :href="link" class="btn btn-success btn-sm" title="مشاهده" data-toggle="tooltip"><i class="dripicons dripicons-preview"></i></a>
            `
        },
        EditLink: {
            props: {link: {required: true}},
            template: `
                <a :href="link" class="btn btn-primary btn-sm" title="ویرایش" data-toggle="tooltip"><i class="dripicons dripicons-document-edit"></i></a>
            `
        },
    }
}
